import {
  FaCode,
  FaLayerGroup,
  FaDatabase,
  FaCloud,
  FaMobileAlt,
  FaCubes,
} from "react-icons/fa";

export const services = [
  {
    icon: FaCode,
    title: "Development",
    color: "#4F46E5",
    description:
      "We build reliable web applications that are fast, scalable, and easy to maintain — focused on real business needs, not demos.",
  },
  {
    icon: FaLayerGroup,
    title: "UI / UX Design",
    color: "#e4da0f",
    description:
      "We create intuitive and engaging user interfaces that enhance user experience and drive customer satisfaction.",
  },
  {
    icon: FaDatabase,
    title: "Backend Systems",
    color: "#10B981",
    description:
      "Robust backend systems built for performance, security, and long-term scalability—not quick hacks.",
  },
  {
    icon: FaCloud,
    title: "Cloud Solutions",
    color: "#d97706",
    description:
      "Cloud infrastructure designed for stability, cost control, and smooth scaling as your product grows.",
  },
  {
    icon: FaMobileAlt,
    title: "Mobile Apps",
    color: "#EF4444",
    description:
      "High-performance mobile apps built for real users—clean UX, solid architecture, and production-ready code.",
  },
  {
    icon: FaCubes,
    title: "Product Engineering",
    color: "#8B5CF6",
    description:
      "End-to-end product development—from idea to production—built with ownership, discipline, and clarity.",
  },
];
